import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import * as React from 'react';

interface Props {
  regionLabel: string;
}

export const ComingSoonBanner: React.FC<Props> = (props) => {
  const { regionLabel } = props;
  return (
    <div className="bg-surface-interactive-hover-4 flex items-center gap-2 px-4 py-4 w-full">
      <ExclamationCircleIcon
        className="text-icon-informative-warning-1 shrink-0"
        style={{ width: 24 }}
      />
      <h4 className="text-text-interactive-accent-3">
        Track and trace will be coming soon for {regionLabel}, but is currently not available.
      </h4>
    </div>
  );
};
ComingSoonBanner.displayName = 'TtrackAndTrace.ComingSoonBanner';
